import apiService from './api';

export interface Notification {
  _id: string;
  title: string;
  message: string;
  type: 'new_complaint' | 'status_update' | 'sla_warning' | 'sla_breach';
  relatedComplaint?: {
    _id: string;
    locationName: string;
    status: string;
  };
  isRead: boolean;
  readAt?: string;
  sentAt: string;
  createdAt: string;
}

export interface NotificationResponse {
  count: number;
  notifications: Notification[];
}

/**
 * Get all notifications for current user
 */
export const getNotifications = async (params?: {
  isRead?: boolean;
  type?: string;
}): Promise<NotificationResponse> => {
  return await apiService.getNotifications(params);
};

/**
 * Get unread notification count
 */
export const getUnreadCount = async (): Promise<number> => {
  return await apiService.getUnreadCount();
};

/**
 * Mark notification as read
 */
export const markAsRead = async (notificationId: string): Promise<void> => {
  await apiService.markNotificationAsRead(notificationId);
};

/**
 * Mark all notifications as read
 */
export const markAllAsRead = async (): Promise<void> => {
  await apiService.markAllNotificationsAsRead();
};

/**
 * Delete notification
 */
export const deleteNotification = async (notificationId: string): Promise<void> => {
  await apiService.deleteNotification(notificationId);
};

/**
 * Delete all read notifications
 */
export const deleteAllRead = async (): Promise<void> => {
  await apiService.deleteAllReadNotifications();
};
